// Centralized attendance constants — import from here, never duplicate

export const ATTENDANCE_STATUSES = [
  { id: 'Present',      label: 'Present',       color: '#2dce89', icon: 'fas fa-check-circle' },
  { id: 'Absent',       label: 'Absent',        color: '#f5365c', icon: 'fas fa-times-circle' },
  { id: 'HalfDay',      label: 'Half Day',      color: '#fb6340', icon: 'fas fa-adjust' },
  { id: 'Leave',        label: 'Leave',         color: '#11cdef', icon: 'fas fa-umbrella-beach' },
  { id: 'WeekOff',      label: 'Week Off',      color: '#8898aa', icon: 'fas fa-coffee' },
  { id: 'Holiday',      label: 'Holiday',       color: '#825ee4', icon: 'fas fa-star' },
  { id: 'WorkFromHome', label: 'Work From Home', color: '#5e72e4', icon: 'fas fa-home' },
];

export const LEAVE_TYPES = [
  { id: 'Casual',       label: 'Casual Leave' },
  { id: 'Sick',         label: 'Sick Leave' },
  { id: 'Annual',       label: 'Annual Leave' },
  { id: 'WorkFromHome', label: 'Work From Home' },
  { id: 'Unpaid',       label: 'Unpaid Leave' },
];

export const LEAVE_APPROVAL_STATUSES = [
  { id: 'Pending',  label: 'Pending',  color: '#fb6340' },
  { id: 'Approved', label: 'Approved', color: '#2dce89' },
  { id: 'Rejected', label: 'Rejected', color: '#f5365c' },
];

// helpers — single source of truth
export const getAttendanceStatus = (id) =>
  ATTENDANCE_STATUSES.find((s) => s.id === id) ?? { label: id ?? 'Unknown', color: '#8898aa', icon: 'fas fa-question' };

export const getLeaveType = (id) =>
  LEAVE_TYPES.find((t) => t.id === id)?.label ?? id ?? 'Unknown';

export const getApprovalStatus = (id) =>
  LEAVE_APPROVAL_STATUSES.find((s) => s.id === id) ?? { label: id ?? 'Unknown', color: '#8898aa' };

export const fmtMinutes = (minutes) => {
  if (!minutes) return '—';
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${h}h ${m}m`;
};

export const fmtTime = (dt) => {
  if (!dt) return '—';
  return new Date(dt).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' });
};

export const fmtDate = (dt) => {
  if (!dt) return '—';
  return new Date(dt).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};
